<form (ngSubmit)="onSubmit()" [formGroup]="formGroup" test-id="cookie-settings-modal">
	<div class="obg-m-cookie-settings-content">
		<h2>{{ "cookie-settings.necessary-cookies" | translate }}</h2>
		<p [innerHtml]="'cookie-settings.necessary-cookies.description.desktop' | translate"></p>
		<div>
			<mat-slide-toggle color="primary" [disabled]="true" [checked]="true"
				>{{ "cookie-settings.necessary-cookies" | translate }}</mat-slide-toggle
			>
		</div>
	</div>

	<div class="obg-m-cookie-settings-content">
		<h2>{{ "cookie-settings.cookie-consent" | translate }}</h2>
		<p [innerHtml]="'cookie-settings.cookie-consent.description' | translate"></p>
		<div>
			<mat-slide-toggle
				color="primary"
				formControlName="cookieConsent"
				test-id="Common-Customer-consent.advertising-cookies-title-input"
				>{{ "cookie-settings.cookie-consent" | translate }}</mat-slide-toggle
			>
		</div>
	</div>

	<button
		mat-flat-button
		color="accent"
		[disabled]="(!isChanged || isLoading)"
		test-id="cookie-settings-submit-button"
	>
		<span *ngIf="!isLoading; else loading">{{ "cookie-settings.save-settings" | translate }}</span>
		<ng-template #loading><mat-spinner diameter="20"></mat-spinner></ng-template>
	</button>
</form>
